import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestPageAttachmentsService {
	private http = inject(HttpClient);
	private authLoginService = inject(AuthLoginService);

	private getLogFile = environment.baseApiUrl + 'request/fileAttach/{fileName}';

	constructor() {}

	getFile(fileName: string): Observable<mspFileInterface> {
		const getLogFile = this.getLogFile.replace('{fileName}', fileName);
		return this.http.get(getLogFile, { headers: this.authLoginService.getHttpHeaders() }).pipe(
			map((fileRes: any) => {
				const newMspFile: mspFileInterface = {
					content: fileRes.content,
					name: fileRes.name,
					mimeType: fileRes.mimeType,
					extension: fileRes.extension,
					size: 0,
					file_path: '',
				};

				return newMspFile;
			})
		);
	}
}
